import React, { Component } from 'react';
import $ from 'jquery';

class SelectionCriteriaModal extends Component {
    constructor(props){
        super(props);
        this.state = {
            ignoreProp: true,
            selectAll: false,
            selectProperties: [],
            rBtn: 'O',
            exactMatch: true,
        }
    }

    componentDidMount(){
        this.closeAction();
    }

    closeModal = async () => {
        $('#SelectionCriteriaModal').modal('hide');
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#SelectionCriteriaModal').on('hidden.bs.modal', function () {});
    };

    closePropertiesModal = () => {
        this.setState({ignoreProp: true, selectProperties: [], rBtn: 'O', exactMatch: true});        
        $('#PropertiesModal').modal('hide');
    };

    renderPropMessage = () => {
        const { ignoreProp, selectProperties, rBtn, exactMatch } = this.state;
        const totalProp = selectProperties.filter(prop => prop && prop.checked === true).length;
        
        if (ignoreProp || (!exactMatch && totalProp < 1)) {
            return 'Ignorar';
        }
    
        if (totalProp > 0) {
            const exactMatchMessage = exactMatch ? 'Coincidencia exacta ' : '';
            return `${exactMatchMessage}${totalProp} ${totalProp === 1 ? 'propiedad' : 'propiedades'} (${rBtn})`;
        }
    
        return 'Ninguna de las propiedades';
    }
    
    onChangeInputs = (e) => {
        const { newOrderModel, refreshModel } = this.props;
        let { name, value, type, checked } = e.target;

        newOrderModel[name] = value;
        refreshModel(newOrderModel);
    }

    selectPropertie = (index, checked) => {
        const selectPropertiesCopy = [...this.state.selectProperties];
      
        if (index >= 0 && index < selectPropertiesCopy.length) {
          selectPropertiesCopy[index] = { ...selectPropertiesCopy[index], checked };
        } else {
          selectPropertiesCopy[index] = { checked };
        }
        
        this.setState({ selectProperties: selectPropertiesCopy });
    }

    selectAll = () => {
        const { newOrderModel, refreshModel } = this.props;
        newOrderModel.CustomerCode = '';
        newOrderModel.CustomerCode2 = '';
        newOrderModel.AllPartners = true;
        refreshModel(newOrderModel);
    }

    renderPropertiesModal = () => {
        const { ignoreProp, selectProperties, rBtn, exactMatch } = this.state;
        const { PartnerProperties } = this.props.newOrderModel;
        const disabledStyle = ignoreProp ? { pointerEvents: 'none', opacity: 0.5 } : {};

        return(
            <div className="modal fade bd-example-modal-lg modal-open scroll" id="PropertiesModal" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog modal-dialog-centered modal-lg modal-open" role="document" style={{maxWidth: 500}}>
                    <div className="modal-content">
                        <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h5 className="modal-title" id="modal-basic-title">Propiedades</h5>
                            <button type="button" className="close" onClick={()=>  this.closePropertiesModal()} aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="w-100 tab-pane fade show active" aria-labelledby="nav-home-tab-Contenido">
                                            <div className="row pr-0">
                                                <div className="col-sm-12">
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={(e)=> this.setState({ignoreProp: e.target.checked})}
                                                                    checked={ignoreProp}/>
                                                            </span>
                                                        </div>
                                                        <label className="form-control">Ignorar propiedades</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row"style={disabledStyle}>
                                                <div className="col-sm-12">
                                                    <div className="input-group mb-3">
                                                        <label className="form-control">Enlace</label>
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text form-radio">
                                                                <input
                                                                    type="radio"
                                                                    onChange={()=> this.setState({rBtn: 'O'})}
                                                                    checked={rBtn === 'O'}/>
                                                            </span>
                                                        </div>
                                                        <label className="form-control text-center">O bien</label>
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text form-radio">
                                                                <input
                                                                    type="radio"
                                                                    onChange={()=> this.setState({rBtn: 'Y'})}
                                                                    checked={rBtn === 'Y'}/>
                                                            </span>
                                                        </div>
                                                        <label className="form-control">Y</label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12">
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={(e)=> this.setState({exactMatch: e.target.checked})}
                                                                    checked={exactMatch}/>
                                                            </span>
                                                        </div>
                                                        <label className="form-control">Coincidencia exacta</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="table-scroll" style={{...disabledStyle, maxHeight: 300 }}>
                                                <table
                                                    id="dataTable-0"
                                                    className="display table-hover"
                                                    style={{ width: '100%', marginBottom: 40, marginRight: -30000 }}>
                                                    <thead className="table-header-yellow">
                                                        <tr style={{ textAlign: "left"}}>
                                                            <td className="sticky-column sticky-header" style={{ background: "#d2ab24", width: 40 }}>#</td>
                                                            <td className="sticky-header" style={{ background: "#d2ab24" }}>Propiedad</td>                    
                                                            <td className="sticky-header" style={{ background: "#d2ab24" }}></td>                                        
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {PartnerProperties.map((propertie, index) => (
                                                            <tr className="small" style={{ textAlign: "left" }} key={index}>
                                                                <td className="sticky-column" style={{ background: '#FFF', width: 40 }}>{index + 1}</td>                    
                                                                <td>{propertie.GroupName}</td>                    
                                                                <td>
                                                                    <div className='form-check'>
                                                                        <input
                                                                            type="checkbox"
                                                                            onChange={(e) => this.selectPropertie(index, e.target.checked)}
                                                                            checked={selectProperties[index]?.checked || false}
                                                                        />
                                                                    </div>
                                                                </td>                    
                                                            </tr>                                                        
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer d-flex justify-content-between">
                            <button type="button" className="btn btn-primary mr-2" onClick={() => this.props.actionProperties(false)}>OK</button>
                            <button type="button" className="btn btn-dark" onClick={() => this.closePropertiesModal(false)}>Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { newOrderModel, openPartner, actionProperties, partnersForAssistant } = this.props;
        const { CustomerCode, CustomerCode2, PartnerGroups, PartnerGroup } = newOrderModel;

        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll" id="SelectionCriteriaModal" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-dialog-centered modal-lg modal-open" role="document">
                        <div className="modal-content">
                            <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h5 className="modal-title" id="modal-basic-title">Socios de negocios - Criterios de selección</h5>
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="container">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="w-100 tab-pane fade show active" aria-labelledby="nav-home-tab-Contenido">
                                                <div className="row pr-0">
                                                    <div className="col-sm-12">
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Código</span>
                                                            </div>
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Desde</span>
                                                            </div>
                                                            <input 
                                                                type="text" 
                                                                className="form-control"
                                                                name="CustomerCode"
                                                                onChange={this.onChangeInputs}
                                                                onKeyPress={(ev) => { if (ev.key === 'Enter') { openPartner(); } }}
                                                                value={CustomerCode} 
                                                            />
                                                            <button type="button" style={{ backgroundColor: 'transparent', color: '#EABF28' }} className="input-group-text" onClick={()=> openPartner()}>
                                                                <i className="fa fa-user fa-lg" aria-hidden="true" />
                                                            </button>
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Hasta</span>
                                                            </div>
                                                            <input 
                                                                type="text" 
                                                                className="form-control"
                                                                name="CustomerCode2"
                                                                onChange={this.onChangeInputs}
                                                                onKeyPress={(ev) => { if (ev.key === 'Enter') { openPartner(null, 'CustomerCode2'); } }}
                                                                value={CustomerCode2} 
                                                            />
                                                            <button type="button" style={{ backgroundColor: 'transparent', color: '#EABF28' }} className="input-group-text" onClick={()=> openPartner(null, 'CustomerCode2')}>
                                                                <i className="fa fa-user fa-lg" aria-hidden="true" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-8">
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Grupo de clientes</span>
                                                            </div>
                                                            <select 
                                                                className="form-control"
                                                                name="PartnerGroup"
                                                                onChange={this.onChangeInputs}
                                                                value={PartnerGroup}
                                                            >
                                                                <option value={-1}>Todos</option>
                                                                {PartnerGroups.map((group, index) => (
                                                                    <option key={index} value={group.GroupCode}>{group.GroupName}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4">
                                                    </div>
                                                    {/* <div className="col-sm-2 d-flex justify-content-start align-items-center mb-3">
                                                        <button type="button" className="btn btn-secondary mr-2" onClick={()=> actionProperties(true)}>Propiedades</button>
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <input type="text" className="form-control" disabled value={this.renderPropMessage()} />
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer d-flex justify-content-between">
                                <div>
                                    <button type="button" className="btn btn-primary mr-2" onClick={() => partnersForAssistant()}>OK</button>
                                    <button type="button" className="btn btn-dark" onClick={this.closeModal}>Cancelar</button>
                                </div>
                                {/* <button type="button" className="btn btn-dark" onClick={this.selectAll}>Seleccionar todo</button> */}
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderPropertiesModal()}
            </div>
        );
    }
}

export default SelectionCriteriaModal;